import CodeIcon from '@mui/icons-material/Code';
import EditIcon from '@mui/icons-material/Edit';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type React from 'react';
import type { EditBusinessUnitPromptToolArguments } from 'services/types/ticket';

import MessageWrapper from './MessageWrapper';
import TextEdit from './TextEdit';

interface Props {
  args: string;
}

const EditPromptToolComponent: React.FC<Props> = ({ args }) => {
  let parsedArgs: EditBusinessUnitPromptToolArguments;

  try {
    parsedArgs = JSON.parse(args) as EditBusinessUnitPromptToolArguments;
  } catch (_error) {
    return (
      <MessageWrapper caption="Herramienta de Edición" align="left">
        <Typography color="error">Error al parsear argumentos: {args}</Typography>
      </MessageWrapper>
    );
  }

  return (
    <MessageWrapper caption="Editar unidad de negocio" align="left">
      <Box>
        <Box
          sx={{
            mb: 1,
          }}
        >
          <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
            <EditIcon sx={{ fontSize: 16, mr: 1, verticalAlign: 'text-bottom' }} />
            Business Unit:
          </Typography>
          <Typography variant="body2" sx={{ fontFamily: 'monospace', bgcolor: 'grey.100', p: 1, borderRadius: 1 }}>
            {parsedArgs.businessUnitId}
          </Typography>
        </Box>

        <Box
          sx={{
            mb: 1,
          }}
        >
          <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
            <CodeIcon sx={{ fontSize: 16, mr: 1, verticalAlign: 'text-bottom' }} />
            Modificaciones:
          </Typography>
          <Box sx={{ maxHeight: '300px', overflow: 'auto' }}>
            <TextEdit codeEdit={parsedArgs.promptEdits || ''} />
          </Box>
        </Box>
      </Box>
    </MessageWrapper>
  );
};

export default EditPromptToolComponent;
